<template>
    <div>

        <Head :title="`Erstelle eine neue Domain`" />
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-primary-100 hover:text-primary-200" href="/domains">Domains</Link>
            <span class="text-primary-100 font-medium">/</span>
            Erstelle eine neue Domain
        </h1>

        <div class="max-w-full overflow-hidden">
            <form @submit.prevent="store" class="flex flex-wrap items-start">
                <div class="flex flex-wrap max-w-3xl -mb-8 mr-6 p-8 bg-white rounded-md shadow">
                    <text-input v-model="form.domain" :error="form.errors.domain" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Name der Domain" />
                    <select-input v-model="form.customer_id" :error="form.errors.customer_id"
                        class="pb-8 pr-6 w-full lg:w-1/2" label="Kunde">
                        <option :value="null" />
                        <option v-for="customer in customers" :key="customer.id" :value="customer.id">{{ customer.name
                        }}</option>
                    </select-input>

                    <div class="datepicker-wrap pb-8 pr-6 w-full lg:w-1/2">
                        <label class="form-label">Bestellt am:</label>
                        <vue-date-picker timezone="UTC" :exact-match="true" :start-time="startTime"
                            input-class-name="dp-custom-input" v-model="form.ordered_at" :format="'dd.MM.yy'"
                            locale="de" :enable-time-picker="false" cancelText="abbrechen"
                            selectText="auswählen"></vue-date-picker>
                    </div>

                    <text-input v-model="form.end" :error="form.errors.end" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Endung" />
                    <textarea-input v-model="form.comment" :error="form.errors.comment"
                        class="pb-8 pr-6 w-full lg:w-full" label="Bemerkung" />

                    <text-input v-model="form.package" :error="form.errors.package" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Paket" />
                    <div class="flex mb-8 items-center w-full mt-8">
                        <div class="border-t border-4 border-gray-400 flex-grow"></div>
                        <div class="px-3 text-gray-400 text-m">Optionale Felder: können automatisch befüllt werden.</div>
                        <div class="border-t border-4 border-gray-400 flex-grow"></div>
                    </div>
                    <text-input v-model="form.server_ip" :error="form.errors.server_ip"
                        class="pb-8 pr-6 w-full lg:w-1/2" label="Server IP" />

                    <text-input v-model="form.dns" :error="form.errors.dns" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="DNS" />
                    <text-input v-model="form.registrar" :error="form.errors.registrar"
                        class="pb-8 pr-6 w-full lg:w-1/2" label="Registrar" />

                    <text-input v-model="form.mail_ip" :error="form.errors.mail_ip" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Mail IP" />
                    <text-input disabled v-model="form.server_name" :error="form.errors.server_name"
                        class="pb-8 pr-6 w-full lg:w-1/2" label="Servername" />
                </div>

                <div class="flex flex-wrap w-full lg:max-w-sm p-8 bg-white rounded-md shadow">
                    <div class="checkbox-wrap pr-6 w-full">
                        <checkbox-input v-model="form.active" :error="form.errors.active" label="Aktiv" />
                    </div>

                    <hr class="w-full bg-gray-200 h-px mt-6 mb-6">

                    <div class="checkbox-wrap pr-6 w-full lg:w-1/2">
                        <checkbox-input v-model="form.flaged" :error="form.errors.active" label="Gekündigt" />
                    </div>
                    <div class="checkbox-wrap pr-6 w-full lg:w-1/2">
                        <checkbox-input v-model="form.charged" :error="form.errors.active" label="Wird abgerechnet" />
                    </div>

                    <hr class="w-full bg-gray-200 h-px mt-6 mb-6">

                    <div v-if="form.flaged" class="datepicker-wrap pb-8 pr-6 w-full">
                        <label class="form-label">Gekündigt zum:</label>
                        <vue-date-picker timezone="UTC" :exact-match="true" :start-time="startTime"
                            input-class-name="dp-custom-input" v-model="form.cancel_date" :format="'dd.MM.yy'"
                            locale="de" :enable-time-picker="false" cancelText="abbrechen"
                            selectText="auswählen"></vue-date-picker>
                    </div>

                    <div v-if="form.charged" class="datepicker-wrap pb-8 pr-6 w-full lg:w-1/2">
                        <label class="form-label">Berechnet am:</label>
                        <vue-date-picker timezone="UTC" :exact-match="true" :start-time="startTime"
                            :enable-time-picker="false" input-class-name="dp-custom-input" v-model="form.charged_till"
                            :format="'dd.MM.yy'" locale="de" cancelText="abbrechen"
                            selectText="auswählen"></vue-date-picker>
                    </div>

                    <text-input v-if="form.charged" v-model="form.amount_net" :error="form.errors.amount_net"
                        class="pb-8 pr-6 w-full lg:w-1/2" label="Betrag/NETTO" />
                </div>

                <div class="w-full max-w-3xl flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <div class="ml-auto flex">
                        <loading-button :loading="form.processing" class="btn-primary-100"
                            type="submit">Speichern</loading-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import CheckboxInput from '@/Shared/CheckboxInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { Inertia } from '@inertiajs/inertia'
import { onUnmounted } from 'vue'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        CheckboxInput,
        VueDatePicker
    },
    layout: Layout,
    props: {
        customers: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                domain: '',
                customer_id: null,
                active: true,
                due_date: '',
                charged: false,
                end: '',
                ordered_at: '',
                charged_till: '',
                comment: '',
                package: '',
                dns: '',
                registrar: '',
                server_ip: '',
                mail_ip: '',
                server_name: '',
                flaged: false,
                cancel_date: '',
                amount_net: ''
            }),
            startTime: { hours: 0, minutes: 0 },
        }
    },
    methods: {
        store() {
            this.form.post('/domains')
        },
    },
}
</script>